import React from 'react'
import SubscriptionPackages from '../SubscriptionPackages'

const AdminSubscription = () => {
  return (
    <div>
      <SubscriptionPackages />
    </div>
  )
}

export default AdminSubscription
